


































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import CellShiftModal from './modals/cellShiftModal.vue';
import { cloneDeep } from 'lodash';
import { lxReportClick } from '@/utils/directive/lxanaly';
import { OncallReportMap } from '@/config/lx.conf';
const TODAY: number = new Date(new Date().setHours(0, 0, 0, 0)).valueOf();
@Component({
    components: {
        CellShiftModal
    }
})
export default class ShiftCell extends Vue {
    @Prop({ default: () => ({}) }) data: CommonTypes.mapObject;
    @Prop({ default: () => ({}) }) member: CommonTypes.mapObject;
    @Prop({ default: () => [] }) shiftList: CommonTypes.mapObject[];
    @Prop({ default: 0 }) timestamp: number;
    @Prop({ default: null }) endDate: Date;

    displayShiftList: CommonTypes.mapObject[] = []; // 用于在单元格中展示的班次list，如果有“全天”，则为空
    allShiftList: CommonTypes.mapObject[] = []; // 用于在弹窗中展示的班次list，包括“全天”
    shift: CommonTypes.mapObject[] = [];
    type: string = '';
    showCellModal: boolean = false;
    modalPosition = {
        left: 0,
        top: 0
    };

    @Watch('data', { immediate: true, deep: true })
    onTypeChanged() {
        if (this.data) {
            this.type = this.data.type;
            this.shift = cloneDeep(this.data.shift);
            if (this.data.type === 'shift') {
                // 根据班次个数处理
                if (this.shift.length > 4) {
                    this.displayShiftList = this.shift.slice(0, 3).concat([
                        {
                            shiftId: 0,
                            abbreviation: `+${this.shift.length - 3}`
                        }
                    ]);
                } else {
                    this.displayShiftList = cloneDeep(this.shift);
                }
            } else {
                this.displayShiftList = [];
            }
            this.formatAllShiftList();
        }
    }
    @Watch('shiftList', { deep: true })
    onShiftListChanged() {
        this.formatAllShiftList();
    }
    formatAllShiftList() {
        this.allShiftList = this.shiftList.map(shift => {
            return {
                ...shift,
                selected:
                    shift.color === 'ALL'
                        ? this.data.type === 'wholeDay' || this.data.type === 'wholeDayOffline'
                        : !!this.data.shift?.find(item => item.shiftId === shift.id)
            };
        });
    }
    onCellClick() {
        if (this.disableClick) return;
        lxReportClick(OncallReportMap.edit_date_oncall);
        this.calculateModalPosition();
        this.showCellModal = true;
    }
    // 计算弹窗应该出现的位置
    calculateModalPosition() {
        const el = document.getElementById(`${this.timestamp}-${this.member.identify}`);
        const { top, right, left } = el.getBoundingClientRect();
        const windowWidth = window.innerWidth;
        const windowHeight = window.innerHeight;
        const modalHeight = 165 + 36 * this.allShiftList.length;
        // 默认在el的右侧展示，当右侧宽度不够时，在左侧展示
        // 根据窗口高度和弹窗高度，判断纵向位置
        // TODO：用屏幕中间位置兜底
        this.modalPosition = {
            top: windowHeight - top > modalHeight ? top : windowHeight - modalHeight,
            left: windowWidth - right > 330 ? right + 10 : left - 330
        };
    }
    onModalClose() {
        this.$emit('close');
    }
    onSuccess() {
        lxReportClick(OncallReportMap.submit_date_oncall);
        this.$emit('success');
    }
    get disableClick() {
        // 不可操作日期不可点击、被删除的值班人不可点击、请假/请假中不可点击
        return (
            this.member.deleted ||
            this.timestamp < TODAY ||
            this.timestamp > this.endDate.getTime() ||
            this.type === 'dayOff' ||
            this.type === 'dayOffPending'
        );
    }
}
